const SELECTORS = {
  section: '.section-article-list',
  loadMoreBttn: '[data-load-more-articles]',
  articlesList: '.blog__article-list',
  allPages: '[data-all-pages]',
  currentPage: '[data-this-page]',
  blogURL: '[data-blog-url]',
  articlesNextPageURL: '[data-next-link]',
};

const articleLoadMore = {
  /**
   * Settings and dom elements
   */
  cacheDOM() {
    this.dom = {};
    this.dom.section = document.querySelector(SELECTORS.section);
    this.dom.loadMoreBttn = document.querySelector(SELECTORS.loadMoreBttn);
    this.deafaultBtnText = this.dom.loadMoreBttn?.textContent;
    this.dom.articlesList = document.querySelector(SELECTORS.articlesList);
    this.dom.currentPageInput = document.querySelector(SELECTORS.currentPage);
    this.dom.articlesNextPageURLInput = document.querySelector(SELECTORS.articlesNextPageURL);
  },
  /**
   *
   */
  setPaginationValues() {
    this.totalPages = +document.querySelector(SELECTORS.allPages).value;
    this.currentPage = +document.querySelector(SELECTORS.currentPage).value;
    this.blogURL = document.querySelector(SELECTORS.blogURL).value;
    this.articlesNextPageURL = document.querySelector(SELECTORS.articlesNextPageURL).value;
  },
  /**
   * Listen events
   */
  eventListener() {
    this.dom.loadMoreBttn?.addEventListener('click', () => {
      this.dom.loadMoreBttn.setAttribute('disabled', true);
      this.dom.loadMoreBttn.textContent = window.theme.strings.accessibility.loading;
      this.setPaginationValues();
      this.fetchArticles();
    });
  },

  /**
   * Fetch html with articles
   */
  fetchArticles() {
    fetch(this.articlesNextPageURL, {
      method: 'GET',
    })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        this.renderArticles(doc);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  /**
   * @param {Document} doc next page html
   */
  renderArticles(doc) {
    const newArticles = doc.querySelector(SELECTORS.articlesList).querySelectorAll('.blog__article-item');
    if (newArticles.length > 0) {
      newArticles.forEach((item, index) => {
        item.querySelector('.article-item').setAttribute('style', `--delay-offset-multiplier: ${index};`);
        item.classList.add('blog__article-item--loaded');
        this.dom.articlesList.append(item);
        setTimeout(() => {
          this.dom.articlesList.querySelectorAll('.blog__article-item--loaded').forEach((loadedItem) => {
            loadedItem.classList.remove('blog__article-item--loaded');
          });
        }, 670 * index);
      });
    }
    this.dom.loadMoreBttn.removeAttribute('disabled');
    this.dom.loadMoreBttn.textContent = this.deafaultBtnText;
    this.currentPage += 1;
    this.dom.currentPageInput.value = this.currentPage;
    this.dom.articlesNextPageURLInput.value = `${this.blogURL}/?page=${this.currentPage + 1}`;
    if (this.currentPage >= this.totalPages) {
      this.dom.loadMoreBttn.setAttribute('disabled', true);
      this.dom.loadMoreBttn.classList.add('hidden');
    }
  },
  /**
   * Initialize nessesary methods
   */
  init() {
    this.cacheDOM();
    this.eventListener();
  },
};

document.addEventListener('DOMContentLoaded', articleLoadMore.init());
